module.exports = __webpack_public_path__ + "static/media/xiaoyu-win.c8b7134a.png";